export function getData () {
  try {
    const keys = Object.keys(localStorage).filter((item) => /\d{13}/.test(item) && getItem(item))
    const items = keys.map((id) => {
      return getItem(Number.parseInt(id))
    })
    return items.sort((a, b) => b.time - a.time)
  } catch (err) {
    console.log('getData' + err)
  }
}

export const setItem = (item) => {
  const predata = getData()
  const len = predata.length
  if (len > 49) {
    localStorage.removeItem(predata[len - 1].time)
  }
  try {
    if (window.localStorage) {
      const time = new Date().getTime()
      if (item) {
        const mod = Object.assign(item, { time })
        const data = JSON.stringify(mod)
        localStorage.setItem(time, data)
      }
    } else {
      console.log('储存失败')
    }
  } catch (err) {
    console.log('setItem' + err)
  }
}

export const getItem = (id) => {
  try {
    if (window.localStorage) {
      const result = localStorage.getItem(id)
      return JSON.parse(result)
    } else {
      console.log('获取失败')
    }
  } catch (err) {
    console.log('getItem' + err)
  }
}



// WEBPACK FOOTER //
// ./src/utils/store.js